import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "@/lib/api";

const PortalAuthCtx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/portal/auth/me");
      setUser(r.data);
    } catch {
      // 401 here just means "not signed in" — expected for the public portal login page.
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await api.post("/portal/auth/logout");
    } catch (e) {
      console.warn("portal logout request failed (continuing client-side):", e?.message);
    }
    setUser(null);
    window.location.href = "/portal/login";
  }, []);

  const ctx = useMemo(
    () => ({ user, setUser, loading, checkAuth, logout }),
    [user, loading, checkAuth, logout]
  );

  return <PortalAuthCtx.Provider value={ctx}>{children}</PortalAuthCtx.Provider>;
}

export const usePortalAuth = () => useContext(PortalAuthCtx);
